import { colors } from "../theme";

interface StepIndicatorProps {
  current: number; // 1-5
  total?: number;  // default 5
}

export default function StepIndicator({ current, total = 5 }: StepIndicatorProps) {
  const pct = (current / total) * 100;

  return (
    <div style={{ padding: "0 16px 12px" }}>
      {/* Track */}
      <div
        style={{
          height: 4,
          borderRadius: 2,
          background: colors.surfaceLight,
          overflow: "hidden",
          marginBottom: 8,
        }}
      >
        {/* Fill — purple, NOT green */}
        <div
          style={{
            height: "100%",
            width: `${pct}%`,
            borderRadius: 2,
            background: colors.purple,
            transition: "width 0.3s ease",
          }}
        />
      </div>
      <div style={{ fontSize: 13, color: colors.gray }}>
        Step {current} of {total}
      </div>
    </div>
  );
}
